import {
    SALES_CATEGORY_BY_DAY_SUCCESS,
    SALES_CATEGORY_BY_DAY_LOADING
} from '../actions/SalesCategoryByDay';

const initialState = {
    amazon: {
        salesCategoryByDayData: null,
        isLoading: true
    },
    shopify: {
        salesCategoryByDayData: null,
        isLoading: true
    },
    wholesale: {
        salesCategoryByDayData: null,
        isLoading: true
    },
};

const salesCategoryByDay = (state = initialState, action = {}) => {

    switch (action.type) {
        case SALES_CATEGORY_BY_DAY_SUCCESS:
            return {
                ...state, [action?.vendor]: { salesCategoryByDayData: action.data, isLoading: false }
            };
        case SALES_CATEGORY_BY_DAY_LOADING:
            return { ...state, [action.vendor]: { ...state?.[action.vendor], isLoading: action.isLoading } };

        default:
            return state;
    }
};

export default salesCategoryByDay;
